module.exports = __webpack_public_path__ + "static/media/Nokia Asha 230 Blue.820d8e19.png";